import Swiper_Mobile from 'classes/Swiper_Mobile';
import { load_swiper_init } from 'modules/carousel/load_swiper';

let loaded = false;

export function load_swiper_mobile(){
    document.addEventListener('swiper_ready', swiper_mobile_init);
    load_swiper_init();
}

function swiper_mobile_init(){

    if( loaded ) return;
    loaded = true;

    let initialized = false;
    
    function on_mobile(){

        if( window.innerWidth >= 768 ) return; // mobile devices screen only
        if( initialized ) return; // execute once
        initialized = true;

        window.removeEventListener('resize', on_mobile);
        
        const e = new Event('swiper_mobile_ready');
        e.Swiper_Mobile = Swiper_Mobile;
        document.dispatchEvent(e);
    }

    on_mobile();

    window.addEventListener('resize', on_mobile);
}